import React from 'react';

import classnames from 'classnames/bind';
import style from './manual.module.scss';
const cx = classnames.bind(style);

const InterviewPracticeGateManual = () => {
  return (
    <div className={cx('contentWrap')}>
      <div className={cx('content')}>
        <div className={cx('imageWrap')}>
          <div className={cx('circle', 'first')} />
          <div className={cx('circle', 'lined')} />
          <div className={cx('circle', 'second')} />
          <div className={cx('circle', 'lined')} />
          <div className={cx('circle', 'third')} />
        </div>
        <div className={cx('line')} />
        <div className={cx('description')}>
          <div className={cx('textWrap')}>
            <div className={cx('title')}>
              면접 질문의 숨겨진
              <br />
              의도를 파악할 수 있어요
            </div>
            <div className={cx('desc')}>
              질문에 대한 의도가 궁금하셨죠?
              <br />
              약 10,000 개 면접 질문에
              <br />
              숨겨진 의도를 잡다가 다 알려 드립니다!
            </div>
          </div>
          <div className={cx('textWrap')}>
            <div className={cx('title')}>
              추천 답변과 유사 질문을
              <br />
              확인할 수 있어요
            </div>
            <div className={cx('desc')}>
              추천 답변에서부터 지양해야 할 답변,
              <br />
              유사 질문까지 면접 질문에 대한
              <br />
              다양한 가이드를 제공해 드려요.
            </div>
          </div>
          <div className={cx('textWrap')}>
            <div className={cx('title')}>
              질문의 순서를 마음대로
              <br />
              설정할 수 있어요
            </div>
            <div className={cx('desc')}>
              다양한 질문들의 순서를 변경해 보세요!
              <br />
              어떤 꼬리 질문에도 대비할 수 있는
              <br />
              나만의 질문 리스트를 만들 수 있어요.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InterviewPracticeGateManual;
